/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

export type IconAttribute = {
  id: number;
  name: string;
  icon: string;
};

export type IconAttributes = Array<IconAttribute>;

export default class Icon {
  constructor(
    public id: number,
    public name: string,
    public icon: string
  ) {}

  static fromJSON(json: Record<string, any>): Icon[] {
    /*
    Example input JSON:
   
    "count": 3,
    "next": null,
    "previous": null,
    "results": [
        {
            "id": 1,
            "name": "Leave",
            "icon": "https://cdr-unicc-dev.undigitalid-nonprod.unicc.org/media/icon/Leave_0BNzZRZ.svg"
        },
        {
            "id": 2,
            "name": "Position",
            "icon": "https://cdr-unicc-dev.undigitalid-nonprod.unicc.org/media/icon/Position_tJIdFgQ.svg"
        },
        {
            "id": 3,
            "name": "Spouse",
            "icon": "https://cdr-unicc-dev.undigitalid-nonprod.unicc.org/media/icon/Spouse_1klLvQp.svg"
        }
    ]
}
    */
    const results: Array<Record<string, any>> = json.results || [];
    return results.map((item) => new Icon(item.id, item.name, item.icon));
  }

  toJSON(): Record<string, any> {
    return {
      id: this.id,
      name: this.name,
      icon: this.icon,
    };
  }
}

export type IconQueryData = QueryData<"id" | "name", "icon" | "name">;

export type IconResponseData = Icon[];
